export default "__VITE_ASSET__DD5ZDWOE__"